import React from 'react';
import { Text, View } from 'react-native';
import { getRegularFont } from '../../../../utils/Utils';
import { textPrimary_9_3 } from '../TextComponent/TextStyle';
//= ========================================================================

const ShortInputTextComponent = ({
  globJSON, simPlatform, inputText, whiteBackground, withPrimaryColor, borderColor,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    container: {
      alignSelf: 'center',
      justifyContent: 'center',
      width: 156,
      height: 29,
      backgroundColor: whiteBackground ? colors.app_background_color : colors.light_elements_color,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
      borderColor: borderColor || colors.border_color,
      borderWidth: 0.6,
      paddingStart: 7,

    },
    txtStyle: {
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      color: withPrimaryColor ? colors.primary_font_color : colors.tertiary_icons_color,
    },
  };
  return (
    <View style={myStyles.container}>
      <Text style={[textPrimary_9_3(globJSON, simPlatform), myStyles.txtStyle]}>
        {inputText}
      </Text>
    </View>
  );
};
export default ShortInputTextComponent;
